import { PHONE_REGEX } from 'utilities/helper/phoneValidation'
import * as Yup from 'yup'
export const Schema = Yup.object().shape({
    phone_number: Yup.string()
        .required('شماره تلفن را وارد کنید')
        .matches(PHONE_REGEX, 'شماره وارد شده درست نیست.'),
    number_of_shares: Yup.number()
        .min(0, `حداقل تعداد سهم 0 می باشد`)
        .max(1000, `حداکثر تعداد سهم 1000 می باشد`)
        .typeError('')
        .required('تعداد سهم را وارد کنید'),
    first_name: Yup.string().required('نام را وارد کنید'),
    last_name: Yup.string().required('نام خانوادگی را وارد کنید'),
})
